import keyMirror from 'src/common/utils/keyMirror';
import playerStatuses from 'src/common/utils/playerStatuses';
import PlayCircleSolid from 'src/common/components/shared/svgIcons/player/PlayCircleSolid';
import PauseCircleSolid from 'src/common/components/shared/svgIcons/player/PauseCircleSolid';
import StopCircleSolid from 'src/common/components/shared/svgIcons/player/StopCircleSolid';

// These states should match the statuses for which we return the play icon class below
export const playIconPlayerStatuses = keyMirror(
  [playerStatuses.paused],
  [playerStatuses.stopped],
  [playerStatuses.idle],
  [playerStatuses.loaded],
  [playerStatuses.failed],
);

export const playerIconClasses = {
  play: 'icon-play-circle-outline',
  pause: 'icon-pause-circle-outline',
  stop: 'icon-stop-circle-outline',
};

const getPlayIcon = () => playerIconClasses.play;
const getPlaySvgIcon = () => PlayCircleSolid;
const getPauseSvgIcon = () => PauseCircleSolid;

export const playerStatusToSvgIconMap = {
  [playerStatuses.playing]: (canScrub) =>
    canScrub ? PauseCircleSolid : StopCircleSolid,
  [playerStatuses.paused]: getPlaySvgIcon,
  [playerStatuses.stopped]: getPlaySvgIcon,
  [playerStatuses.idle]: getPlaySvgIcon,
  [playerStatuses.loaded]: getPlaySvgIcon,
  [playerStatuses.failed]: getPlaySvgIcon,
  [playerStatuses.connecting]: () => '',
  [playerStatuses.preroll]: getPauseSvgIcon,
  [playerStatuses.popout]: () => 'icon-popout-circle',
};

export default {
  [playerStatuses.playing]: (canScrub) =>
    canScrub ? playerIconClasses.pause : playerIconClasses.stop,
  [playerStatuses.paused]: getPlayIcon,
  [playerStatuses.stopped]: getPlayIcon,
  [playerStatuses.idle]: getPlayIcon,
  [playerStatuses.loaded]: getPlayIcon,
  [playerStatuses.failed]: getPlayIcon,
  [playerStatuses.connecting]: () => '',
  [playerStatuses.preroll]: getPauseSvgIcon,
  [playerStatuses.popout]: () => 'icon-popout-circle',
};
